import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tax-benefit',
  templateUrl: './tax-benefit.component.html',
  styleUrls: ['./tax-benefit.component.scss']
})
export class TaxBenefitComponent implements OnInit {

  @Input() top;
  @Input() left;

  constructor() { }

  ngOnInit(): void {
  }

}
